// Thumbnail generator
const generateThumbnail = (product, size, focus) => {
  var threeDProds = [8531, 8533, 8532, 8529, 8530];
  var lightingProds = [8534,8527]
  let thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}`;
  // Handles any paint color thumbnails
  if (product.specifier.toString().indexOf("COLOR") === -1 && product.specifier.toString().indexOf("RGB") !== -1) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=COLOR(${product.specifier})&type=prod&extra=(focus=${focus})&Size=${size}`;
  }
  //handle no selection
  else if (parseInt(product.id) === -1) {
    thumbnail = `/thumbs/none.jpg`;
  }
  // Handle cabinet door thumbnails
  else if (parseInt(product.seriesID) === 8496) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&sel=5137548&type=base&extra=(focus=(@SIZE/@IMAGE[1][RES][X]))&Size=${size}&form=png`;
  }
  // Handle door thumbs
  else if(parseInt(product.seriesID) === 8499){
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&size=150&extra=(RX=@apply[1][RES]%7C@image[1][RES],FOCUS=(@size[X]/@RX[X]/1in),size=(Y=(@size[X]*@RX[Y]/@RX[X])))`;
  }
  // Handle door hardware thumbs
  else if(parseInt(product.seriesID) === 8547){
    thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '_')}_${product.color.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '_')}.jpg`;
  }
  // Handle sidelight thumbs
  else if(parseInt(product.seriesID) === 8500){
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&size=100&extra=(RX=@apply[1][RES]%7C@image[1][RES],FOCUS=(@size[X]/@RX[X]/1in),size=(Y=(@size[X]*@RX[Y]/@RX[X])))`;
  }
  // Handle exterior lights thumbs
  else if(parseInt(product.seriesID) === 8548){
    if(product.specifier.includes('Large') || product.specifier.includes('Medium')){
      let size = product.specifier.includes('Large') ? 'large' : 'medium';
      thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/ /g, '_')}_${product.description.replace(/ /g, '_')}_${size}.jpg`;
    }else{
      thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/ /g, '_')}_${product.description.replace(/ /g, '_')}.jpg`;
    }
    
  }
  // Handle interor door and hardware
  else if([8490,8556].indexOf(parseInt(product.seriesID)) != -1){
    thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/ /g, '_')}_${product.color.replace(/ /g, '_')}.jpg`;
  }
  // Handle Baseboard & Chandelier
   else if([8492,8602].indexOf(parseInt(product.seriesID)) != -1){
    thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '_')}.jpg`;
  }
  // Handle cabinet crown
  else if(parseInt(product.seriesID) === 8498){
    thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '_')}.jpg`;
  }
  else if(lightingProds.includes(parseInt(product.seriesID))){
    let imageName = product.color.length > 2 ? product.color : product.id;
    thumbnail = `/thumbs/${product.seriesID}/${imageName}.jpg`;
  }
  else if(parseInt(product.seriesID) === 8528){
    thumbnail = `/thumbs/${product.seriesID}/${product.name.replace(/ /g, '_')}_${product.color.replace(/ /g, '_')}.jpg`;
  }
  // Handle 3D products
  else if(threeDProds.includes(parseInt(product.seriesID))){
    thumbnail = `/thumbs/${product.seriesID}/${product.name}.jpg`;
  }

  return thumbnail;
};

export { generateThumbnail };
